var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comments-list"},_vm._l((_vm.comments),function(comment){return _c('comment',_vm._b({key:comment.id,attrs:{"hashid":comment.id,"cloudapp-links":comment.links.cloudapp_links,"tribute-options":_vm.tributeOptions}},'comment',comment.attributes,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }